import { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import { useIntelligentColorState } from '../states/intelligent-color-state';

export const useInit = () => {
    const editorIdentity = useIdentity();
    const framework = getFramework(editorIdentity);

    const isIntelligent = useIntelligentColorState()((state) => state.isIntelligent);

    // 控制隐藏、显示素材层
    useEffect(() => {
        if (!isIntelligent) return;

        // 禁用图层选中事件，取消激活图层
        framework.operate.disablePick();

        setTimeout(() => {
            framework.operate.delActiveLayer();
        }, 0);

        return () => {
            // 恢复图层选中事件
            framework.operate.enablePick();
        };
    }, [isIntelligent]);
};
